import breakpoints from './Breakpoints';
export default breakpoints;
